import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-121d3ecc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row mt-1",
  id: "moreDetails"
}
const _hoisted_2 = {
  key: 0,
  class: "col-12"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-4" }, null, -1))
const _hoisted_4 = { class: "text-uppercase fw-bold" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "col-12 my-3"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 2,
  class: "col-12 my-3"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "col-12 mb-2" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 3,
  class: "col-12 my-5 d-inline text-end"
}
const _hoisted_14 = { class: "d-flex mx-auto" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-fill text-nowrap me-3" }, "Registrate ahora", -1))


import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/swiper-bundle.css'
import SwiperCore, {
  Navigation,
  Pagination,
  Mousewheel,
  Keyboard
} from 'swiper'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailSeccionSpecial',
  props: {
    title: null,
    subTitle: null,
    imgs: null,
    html: null,
    onlyInfo: null,
    video: null
  },
  setup(__props: any) {

const props = __props as {
  title: string
  subTitle: string
  imgs: { path: string }[]
  html: string
  onlyInfo?: string
  video?: string
};

SwiperCore.use([Navigation, Pagination, Mousewheel, Keyboard])

const router = useRouter()
const {getters} = useStore<VuexStore>(key)



const to = (to: object) => {
  if (to) {
    router.push(to)
  }
}


return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (!props.onlyInfo)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h3", _hoisted_4, _toDisplayString(props.title), 1),
                (props.subTitle)
                  ? (_openBlock(), _createElementBlock("h4", {
                      key: 0,
                      class: "text-uppercase",
                      innerHTML: props.subTitle
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (props.video)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("video", {
            muted: "",
            src: props.video,
            autoplay: "",
            controls: "",
            class: "w-100"
          }, null, 8, _hoisted_7)
        ]))
      : _createCommentVNode("", true),
    (props.imgs.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (props.imgs.length > 1)
            ? (_openBlock(), _createBlock(_unref(Swiper), {
                key: 0,
                navigation: true,
                pagination: true,
                keyboard: true,
                class: "mySwiper",
                "preload-images": true
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.imgs, (img) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                      key: img.path
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: img.path
                        }, null, 8, _hoisted_9)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "w-100",
                src: props.imgs[0].path
              }, null, 8, _hoisted_10))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", {
        class: "contenido-html",
        innerHTML: props.html
      }, null, 8, _hoisted_12)
    ]),
    (!_unref(getters).isLogin && !_unref(getters).porInvitacion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("button", {
            class: "btn d-inline",
            style: {"width":"auto"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (to({ name: 'Register'})))
          }, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_Icon, { icon: ['fas', 'chevron-right'] })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})